// Copyright (c) 2025 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import {closeAmountOfUseModal} from './update-amount-of-use-modal';
import {readAmountOfUseRequests} from './get-amount-of-use-requests';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateAmountOfUse} from '../../shared/repositories';

export const approveDenyAmountOfUse = (actionToTake, itemToUpdate, selectedDealers) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const status = actionToTake === 'APPROVE' ? 'APPROVED' : 'REJECTED';

        const payload = new MeasurementReading({
            ...itemToUpdate,
            ...itemToUpdate.status = status
        });

        try {

            await updateAmountOfUse(payload);

            closeAmountOfUseModal()(dispatch);

            if (status === 'APPROVED') {

                successAlertBar(translate('AMOUNT_OF_USE_ACCEPETD'));

            } else {

                successAlertBar(translate('AMOUNT_OF_USE_REJECTED'));

            }

            readAmountOfUseRequests(selectedDealers)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/approve-deny-amount-of-use.js